import dayjs from "dayjs"
import duration from "dayjs/plugin/duration"
dayjs.extend(duration)

export const formatTimeDiff = (timestampString: string) => {
  const now = dayjs()
  const target = dayjs(timestampString)
  const diff = target.diff(now)

  if (diff > 0) {
    // Time until
    const duration = dayjs.duration(diff)
    const years = duration.years()
    const months = duration.months()
    const days = duration.days()
    const hours = duration.hours()
    const minutes = duration.minutes()

    let formattedTime = ""
    if (years > 0) {
      formattedTime += `${years} year${years > 1 ? "s" : ""}`
    }
    if (months > 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${months} month${months > 1 ? "s" : ""}`
    }
    if (days > 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${days} day${days > 1 ? "s" : ""}`
    }
    if (hours > 0 && years === 0 && months === 0 && days === 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${hours} hour${hours > 1 ? "s" : ""}, ${minutes} minute${minutes > 1 ? "s" : ""}`
    }
    return formattedTime || "less than a minute"
  } else {
    // Time since
    const duration = dayjs.duration(-diff)
    const years = duration.years()
    const months = duration.months()
    const days = duration.days()
    const hours = duration.hours()
    const minutes = duration.minutes()

    let formattedTime = ""
    if (years > 0) {
      formattedTime += `${years} year${years > 1 ? "s" : ""}`
    }
    if (months > 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${months} month${months > 1 ? "s" : ""}`
    }
    if (days > 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${days} day${days > 1 ? "s" : ""}`
    }
    if (hours > 0 && years === 0 && months === 0 && days === 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${hours} hour${hours > 1 ? "s" : ""}, ${minutes} minute${minutes > 1 ? "s" : ""}`
    }
    return formattedTime || "less than a minute"
  }
}
